import React, { useState, useEffect, useCallback, useRef } from "react";
import $ from "jquery";
import { BottomScrollListener, useBottomScrollListener } from "react-bottom-scroll-listener";
import { debounce } from "lodash";
import ErrorModal from "./ErrorModal";
import {
  LOW_DEBOUNCE_TIME,
  SHOP_KEY_FOR_SESSION_STORAGE,
  parseBigInteger,
  parseItemCondition,
  handleBackPage,
  IPAD_WIDTH,
  DESKTOP_WIDTH,
  buildEditableSelect,
  parseGradeOverall,
  enterDownHandler,
  scrollToTopPage,
  displayTranslations,
  getArtwork,
  CURRENCY_EURO,
  parseCategoryName,
  parseAmount,
  parseLanguage,
  titleize,
  pluralize,
  convertLocaleToLanguage,
  DEFAULT_PER_PAGE_PARAM
} from "../../utils/utils";
import ShowLargeImageModal from "./ShowLargeImageModal";
import I18n from 'i18n.js.erb'
import RequiredLoginAlertPopup from "./RequiredLoginAlertPopup.jsx"
import ShopOffertDetailModal from "./ShopOffertDetailModal.jsx"
import ShowBlueprintImageFrontImage from "./ShowBlueprintImageFrontImage";
import SwitchDisplay from "./SwitchDisplay";
import { addCartItemsQuantity } from "../../reducers/cart_icon_reducer";
import { useDispatch } from "react-redux";
import SendEmailModal from "./SendEmailModal";
import SuccessModal from "./SuccessModal";
import EncasingParser from "./EncasingParser";
import BlueprintImageTableRaw from "./BlueprintImageTableRow";
import LanguageFlag from "./LanguageFlag";
import SuccessFlashMessage from "./SuccessFlashMessage";
import GradingCertificate from "./GradingCertificate";


const OffersForMultipleBlueprintImages = ({
  logged_in_user,
  initialOffers,
  blueprintImagesIds,
  owners,
  label_languages,
  categories,
  games,
  eras,
  expansions,
  languages,
  versions,
  rarities,
  sorting_options,
  sorting_directions,
  isBusinessAccount,
  params,
  currentUserEmail,
  currentUsername
}) => {

  const originalOffers = JSON.parse(initialOffers);
  const dispatch = useDispatch()
  const [initCompleted, setInitCompleted] = useState(false)
  const [offers, setOffers] = useState([]);
  const [allProductsIds, setAllProductsIds] = useState([])
  const [allProductsCount, setAllProductsCount] = useState(0)
  const filtersAtLoadingPage = {
    owner: null, label_language: null, encasing: null, condition: null, grade_overall: null,
    has_errors: null, max_price: null,
    name: params && params.name ? params.name : null,
    language: params && params.language ? params.language : null,
    game_id: params && params.game_id ? params.game_id : null,
    category_id: params && params.category_id ? params.category_id : null,
    era_id: params && params.era_id ? params.era_id : null,
    expansion_id: params && params.expansion_id ? params.expansion_id : null,
    language_filter: params && params.language_filter ? params.language_filter : (params && params.language ? convertLocaleToLanguage(params.language) : null),
    version: null, rarity: null, sort_by: 'id', sorting_direction: 'asc'
  }
  const initialFilters = {
    owner: null, label_language: null, encasing: null, condition: null, grade_overall: null,
    has_errors: null, max_price: null, name: null, language: null, game_id: null, category_id: null, era_id: null,
    expansion_id: null, language_filter: null, version: null, rarity: null, sort_by: 'id', sorting_direction: 'asc'
  }
  const [filters, setFilters] = useState(filtersAtLoadingPage)
  const [erasForFilter, setErasForFilter] = useState(eras)
  const [expansionsForFilter, setExpansionsForFilter] = useState(expansions)
  const [page, setPage] = useState(1);
  const [hasLoadedAllOffers, setHasLoadedAllOffers] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSuccessFlashMessage, setShowSuccessFlashMessage] = useState(false)
  const [successFlashMessage, setSuccessFlashMessage] = useState('')
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')
  const [showZoomImg, setShowZoomImg] = useState(false)
  const [showCertificate, setShowCertificate] = useState(false)
  const [blueprintImage2ShowLargeImage, setBlueprintImage2ShowLargeImage] = useState(null)
  const [productToShowGradingCertificate, setProductToShowGradingCertificate] = useState(null)
  const [filterPannelIsOpen, setFilterPannelIsOpen] = useState(window.innerWidth >= DESKTOP_WIDTH);
  const [showRequiredLoginModal, setShowRequiredLoginModal] = useState(false);
  const [showInfoOfferModal, setShowInfoOfferModal] = useState(false);
  const [offerToShow, setOfferToShow] = useState(null);
  const [display, setDisplay] = useState(window.innerWidth > DESKTOP_WIDTH ? "list" : "block");
  const [loadDataFromSessionStorage, setLoadDataFromSessionStorage] = useState(false);
  const [serialNumberToAskToSellerByEmail, setSerialNumberToAskToSellerByEmail] = useState(null)
  const [emailFrom, setEmailFrom] = useState({ username: currentUsername, email: currentUserEmail, text: '' })


  // console.log("all_products_ids: ", allProductsIds);


  useEffect(() => {
    if (initCompleted && offers.length === 0) {
      getOffers(params)
    }
  }, [offers]);


  useEffect(() => {
    if (!initCompleted) {
      setInitCompleted(true)

      let shopPrevData = sessionStorage.getItem(SHOP_KEY_FOR_SESSION_STORAGE);
      if (shopPrevData) {
        shopPrevData = JSON.parse(shopPrevData);
      }
      let shopCurrentUrl = `/products`;
      let functions = {
        setLoadDataFromSessionStorage: setLoadDataFromSessionStorage
      };
      if (shopPrevData && shopPrevData.url === shopCurrentUrl) {
        setOffers([])
        setPage(1)
        handleBackPage(SHOP_KEY_FOR_SESSION_STORAGE, shopPrevData, functions);
      } else {
        setAllProductsIds(originalOffers.on_sale_products_ids)
        setAllProductsCount(originalOffers.all_products_count)
        appendOffers(originalOffers.on_sale_products)
      }

      enterDownHandler(setFilterPannelIsOpen)
    }
  }, []);

  useEffect(() => {
    if (initCompleted) {
      debouncedUpdateFilterPrice();
      return debouncedUpdateFilterPrice.cancel;
    }
  }, [filters.max_price, debouncedUpdateFilterPrice]);

  useEffect(() => {
    if (initCompleted) {
      debouncedUpdateFilterName();
      return debouncedUpdateFilterName.cancel;
    }
  }, [filters.name, debouncedUpdateFilterName]);

  useEffect(() => {
    if (filters.expansion_id)
      setTimeout(() => { $("span.select2-selection.select2-selection--single").addClass("border-aiG-blue-imp"); }, 50)
    else
      $(".select2-selection.select2-selection--single").removeClass("border-aiG-blue-imp");
  }, [filters]);

  useEffect(() => {
    if (showInfoOfferModal === false) {
      setOfferToShow(null)
    }
  }, [showInfoOfferModal]);



  const handleChangeExpansionFilter = (e) => {
    getOffersByMatchingFilters('expansion_id', e.target.value)
  }



  useEffect(() => {
    buildEditableSelect(handleChangeExpansionFilter)
  }, [filterPannelIsOpen, filters]);


  // Funzione che permette di ottenere dal server nuovi prodotti in vendita da renderizzare sull'interfaccia grafica
  const getOffers = (params) => {
    if (!hasLoadedAllOffers) {
      let url = `/products.json?blueprint_images_ids=${blueprintImagesIds}&page=${page}&per_page=${DEFAULT_PER_PAGE_PARAM}`

      Object.entries(filters).forEach(([fieldName, fieldValue]) => {
        if (fieldValue !== null)
          url += `&${fieldName}=${fieldValue}`
      })

      fetch(url, {
        method: 'GET'
      })
        .then(response => response.json())
        .then((data) => {
          setAllProductsIds(data.on_sale_products_ids)
          setAllProductsCount(data.all_products_count)
          setLoading(false)
          appendOffers(data.on_sale_products)
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }


  // Funzione che permette di concatenare i nuovi prodotti in vendita ottenuti del server all'array che contiene tutti i
  // prodotti da mostrare sull'interfaccia grafica all'utente
  const appendOffers = (newOffers) => {
    setOffers(offers.concat(newOffers));
    setPage(page + 1)
    if (newOffers.length < DEFAULT_PER_PAGE_PARAM)
      setHasLoadedAllOffers(true)
  }


  // Funzione che permette di ottenere dal server le carte della my collection dell'utente che matchano con i filtri
  // di ricerca da lui specificati sull'interfaccia grafica
  const getOffersByMatchingFilters = (filter, value) => {
    const newFilters = { ...filters }
    newFilters[filter] = value;
    if (['game_id', 'era_id'].includes(filter))
      newFilters['expansion_id'] = null;
    if (filter === 'game_id')
      newFilters['era_id'] = null;
    updateFilters(newFilters)
  }


  //Funzione che esegue l'update debouncato del filtro di ricerca delle carte per prezzo massimo
  const debouncedUpdateFilterPrice = useCallback(
    debounce(() => updateFilters(filters), LOW_DEBOUNCE_TIME),
    [filters.max_price]
  );


  //Funzione che esegue l'update debouncato del filtro di ricerca delle carte per nome
  const debouncedUpdateFilterName = useCallback(
    debounce(() => updateFilters(filters), LOW_DEBOUNCE_TIME),
    [filters.name]
  );


  //Funzione che setta il nuovo filtro di ricerca delle carte per prezzo massimo
  function onChangeFilterPriceHandler(newFilterPrice) {
    const newFilters = { ...filters }
    newFilters['max_price'] = newFilterPrice;
    setFilters(newFilters)
  }

  //Funzione che setta il nuovo filtro di ricerca delle carte per nome
  function onChangeFilterNameHandler(newFilterName) {
    const newFilters = { ...filters }
    newFilters['name'] = newFilterName;
    setFilters(newFilters)
  }


  // Funzione che aggiorna le opzioni dal filtro di ricerca dei products per ere e per espansioni quando l'utente
  // seleziona uno specifico game per filtrarli
  const filterErasAndExpansionsByGame = (game_id) => {
    const filteredEras = eras.filter(era => (era.game_id == game_id) || (!game_id || game_id === ""))
    const filteredExpansions = expansions.filter(expansion => (expansion.game_id == game_id) || (!game_id || game_id === ""))
    setErasForFilter(filteredEras)
    setExpansionsForFilter(filteredExpansions)
  }


  // Funzione che aggiorna le opzioni dal filtro di ricerca dei products per espansioni quando l'utente
  // seleziona una specifica era per filtrarle
  const filterExpansionsByEra = (era_id) => {
    const filteredExpansions = expansions.filter(expansion => (expansion.era_id == era_id) || (!era_id || era_id === ""))
    setExpansionsForFilter(filteredExpansions)
  }


  // Funzione che aggiorna i filtri di ricerca delle carte specificate dall'utente sull'interfaccia grafica e rilancia
  // la ricerca sulla carte in vendita che matchano con i nuovi filtri specificati
  const updateFilters = (newFilters) => {
    setFilters(newFilters)
    setLoading(true)
    setPage(1)
    setHasLoadedAllOffers(false)
    setOffers([]);
    scrollToTopPage()
  }


  // Funzione che si occupa di resettare tutti i filtri di ricerca specificati dall'utente sull'interfaccia grafica
  const handleResetFilters = () => {
    // $('.select2-custom').val('').trigger('change.select2');
    // updateFilters(initialFilters);
    // setErasForFilter(eras)
    // setExpansionsForFilter(expansions)
    // if (window.innerWidth <= IPAD_WIDTH)
    //   setFilterPannelIsOpen(false)
    window.location = '/products'
  }


  // Funzione che permette di aggiungere un prodotto (o tutti i prodotti renderizzati sull'interfaccia grafica)
  // al carrello degli acquisti dell'utente
  const addCardToCartHandler = (offerId) => {
    if (logged_in_user) {
      const url = "/carts";

      if (offerId) {
        fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items_ids: [offerId] }),
        })
          .then((response) => {
            if (!response.ok)
              throw Error("An error occour during saving data on the database");
            else
              return response.json()
          })
          .then((data) => {
            let newOffers = offers.map((offer) => {
              if (offer.id === offerId) {
                let newOffer = { ...offer }
                newOffer['already_in_cart'] = data.id;
                return newOffer
              }
              return offer;
            })
            setOffers(newOffers)
            dispatch(addCartItemsQuantity(data.cart_items_count))
            setShowSuccessFlashMessage(true)
            setSuccessFlashMessage(I18n.t('js.shopPage.productAddedToCart'))
          })
          .catch((error) => {
            console.error("ERROR:", error);
            setShowErrorModal(true);
          });

      } else if (allProductsIds.length > 0) {
        fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items_ids: allProductsIds }),
        })
          .then((response) => {
            if (!response.ok)
              throw Error("An error occour during saving data on the database");
            else
              return response.json()
          })
          .then((data) => {
            let newOffers = offers.map((offer) => {
              let newOffer = { ...offer }
              if (offer.enable_purchase)
                newOffer['already_in_cart'] = data.id;
              return newOffer
            })
            setOffers(newOffers)
            dispatch(addCartItemsQuantity(data.cart_items_count))
            setShowSuccessFlashMessage(true)
            setSuccessFlashMessage(I18n.t('js.shopPage.productsAddedToCart'))
          })
          .catch((error) => {
            console.error("ERROR:", error);
            setShowErrorModal(true);
          });
      }
    } else {
      setShowRequiredLoginModal(true)
    }
  }


  // Funzione che permette di mostrare in full-screen l'immagine ingrandita di una carta
  const handleShowLargeImage = (e, product, blueprintImage) => {
    e.stopPropagation();
    if (product) {
      setProductToShowGradingCertificate(product)
      setShowZoomImg(true)
    }
    if (blueprintImage && blueprintImage.xx_large_image_url) {
      setBlueprintImage2ShowLargeImage(blueprintImage)
      setShowZoomImg(true)
    }
  }


  //Funzione che gestise l'apertura della modale con il dettaglio del prodotto su cui si è cliccato
  const showDetailOf = (offer) => {
    setOfferToShow(offer);
    setShowInfoOfferModal(true);
  }

  // Funzione che permette di cambiare la modalità di visualizzazione delle offerte da griglia a lista o viceversa
  const switchTab = (e) => {
    e.stopPropagation()
    if (e.target.id === "button-list") {
      setDisplay("list");
    } else {
      setDisplay("block");
    }
  };

  // Funzione che gestisce la navigazione alla pagina che contiene tutte le carte
  // dell'espansione cliccata sull'interfaccia grafica dell'utente
  const handleNavigation = (e, product) => {
    const shopPrevData = {
      url: `/products`,
      scrollY: window.scrollY
    };
    sessionStorage.setItem(SHOP_KEY_FOR_SESSION_STORAGE, JSON.stringify(shopPrevData));

    window.location = `/products/${product.id}`;
    e.stopPropagation();
  };


  // Funzione che permette all'utente corrente di mettersi in contatto con il venditore di un certo prodotto esposto
  // sul marketplace inviandogli una mail
  const handleSendEmailToSeller = () => {
    if (emailFrom && emailFrom.email && emailFrom.text && serialNumberToAskToSellerByEmail) {
      const url = "/products/contact_seller";

      const body = {
        user_from: emailFrom.username,
        email_from: emailFrom.email,
        serial_number: serialNumberToAskToSellerByEmail,
        text: emailFrom.text
      }

      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
        .then((response) => {
          if (!response.ok)
            throw Error("An error occour during saving data on the database");
          else
            return response.json()
        })
        .then((data) => {
          setShowSuccessModal(true)
          setSuccessMessage({ message: I18n.t('js.shopPage.successSendingEmailMessage') })
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }


  return (
    <React.Fragment>
      <div>
        {/*filtri*/}
        <div>
          {
            !filterPannelIsOpen ?
              <React.Fragment>
                <div
                  className={`${JSON.stringify(filters) !== JSON.stringify(initialFilters) && 'icon--bg-active'} rounded-right show-on-desktop expansion__filter--mobile-position top-170px`}>
                  <button type="button" className="btn p-7px"
                    id="open_filter_panel"
                    onClick={(e) => setFilterPannelIsOpen(true)}>
                    <i
                      className={`${JSON.stringify(filters) !== JSON.stringify(initialFilters) ? 'icon--color-active' : 'icon-color-standard'} fas fa-filter enable-filters-expansions-icon`} />
                  </button>
                </div>

                {/*mobile button*/}
                <div
                  className={`${JSON.stringify(filters) !== JSON.stringify(initialFilters) && 'icon--bg-active'} rounded-right show-on-mobile expansion__filter--mobile-position`}>
                  <button type="button" className="btn p-7px"
                    onClick={(e) => setFilterPannelIsOpen(true)}>
                    <i
                      className={`${JSON.stringify(filters) !== JSON.stringify(initialFilters) ? 'icon--color-active' : 'icon-color-standard'} fas fa-filter enable-filters-expansions-icon`} />
                  </button>
                </div>
              </React.Fragment>
              :
              <React.Fragment>
                {
                  filterPannelIsOpen &&
                  <div className="pl-4 pr-4 pb-4 actions-menu-fixed-on-top scrollable-div bg-light overflow-auto shadow z-index-125"
                    id="filters">
                    <div className="row">
                      <div className="col-12 text-right p-lg-0">
                        <button type="button" className="btn p-0 mt-8px mr-4px"
                          id="close_filter_panel"
                          onClick={(e) => setFilterPannelIsOpen(false)}>
                          <i className="fas fa-times" />
                        </button>
                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-12">
                        <h4 className="mt-0 mb-0">{I18n.t('js.filters.by')}</h4>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.filters.sort.cardName')}</p>
                        <input
                          type="text"
                          value={filters.name ? filters.name : ""}
                          className={`form-control ${filters.name ? 'border-aiG-blue-imp' : ''} p-1`}
                          placeholder={I18n.t('js.filters.placeholder.cardName')}
                          onChange={(e) => onChangeFilterNameHandler(e.target.value)}
                          name="card_name_filter"
                          id="card_name_filter"
                        />
                      </div>

                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.filters.sort.cardGame')}</p>
                        <select
                          className={`form-control ${filters.game_id ? 'border-aiG-blue-imp' : ''}`}
                          value={filters.game_id ? filters.game_id : ""}
                          name="game_filter"
                          id="game_filter"
                          onChange={(e) => {
                            filterErasAndExpansionsByGame(e.target.value);
                            getOffersByMatchingFilters('game_id', e.target.value)
                          }}
                        >
                          <option value={""}>{I18n.t('js.filters.game')}</option>
                          {games.map((game) => (
                            <option value={game.id} key={game.id}>
                              {game.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.filters.category')}</p>
                        <select
                          className={`form-control ${filters.category_id ? 'border-aiG-blue-imp' : ''} p-0`}
                          value={filters.category_id ? filters.category_id : ""}
                          name="category_filter"
                          id="category_filter"
                          onChange={(e) => getOffersByMatchingFilters('category_id', e.target.value)}
                        >
                          <option value={""}>{I18n.t('js.filters.defaultCategory')}</option>
                          {categories.map((category) => (
                            <option value={category.id} key={category.id}>
                              {parseCategoryName(category.name)}
                            </option>
                          ))}
                        </select>
                      </div>


                      {
                        erasForFilter && erasForFilter.length > 0 &&
                        <div className="col-lg-2 col-md-3 col-6 mb-2">
                          <p className="mb-0">{I18n.t('js.filters.sort.era')}</p>
                          <select
                            className={`form-control ${filters.era_id ? 'border-aiG-blue-imp' : ''} p-0`}
                            value={filters.era_id ? filters.era_id : ""}
                            name="era_filter"
                            id="era_filter"
                            onChange={(e) => {
                              filterExpansionsByEra(e.target.value);
                              getOffersByMatchingFilters('era_id', e.target.value)
                            }}
                          >
                            <option value={""}>{I18n.t('js.filters.defaultEra')}</option>
                            {erasForFilter.map((era) => (
                              <option value={era.id} key={era.id}>
                                {era.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      }

                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.filters.sort.expansion')}</p>
                        <select
                          className="form-control select2-custom p-0"
                          value={filters.expansion_id ? filters.expansion_id : ""}
                          name="expansion_filter"
                          id="expansion_filter"
                          onChange={(e) => { }}
                        >
                          <option value={""}>{I18n.t('js.filters.defaultExpansion')}</option>
                          {expansionsForFilter.map(expansion => {
                            return <option value={expansion.id} key={expansion.id} label={expansion.icon}>
                              {expansion.name}
                            </option>
                          })}
                        </select>
                      </div>

                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.filters.sort.cardLanguage')}</p>
                        <select
                          className={`form-control ${filters.language_filter ? 'border-aiG-blue-imp' : ''} p-0`}
                          value={filters.language_filter ? filters.language_filter : ""}
                          name="language_filter"
                          id="language_filter"
                          onChange={(e) => getOffersByMatchingFilters('language_filter', e.target.value)}
                        >
                          <option value={""}>{I18n.t('js.filters.defaultCardLanguage')}</option>
                          {languages.map((language) => (
                            <option value={language} key={language}>
                              {parseLanguage(language)}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.filters.sort.rarity')}</p>
                        <select
                          className={`form-control ${filters.rarity ? 'border-aiG-blue-imp' : ''} p-0`}
                          value={filters.rarity ? filters.rarity : ""}
                          name="rarity_filter"
                          id="rarity_filter"
                          onChange={(e) => getOffersByMatchingFilters('rarity', e.target.value)}
                        >
                          <option value={""}>{I18n.t('js.filters.defaultCardRarity')}</option>
                          {rarities.map((rarity) => (
                            <option value={rarity} key={rarity}>
                              {titleize(rarity)}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.filters.sort.version')}</p>
                        <select
                          className={`form-control ${filters.version ? 'border-aiG-blue-imp' : ''} p-0`}
                          value={filters.version ? filters.version : ""}
                          name="version_filter"
                          id="version_filter"
                          onChange={(e) => getOffersByMatchingFilters('version', e.target.value)}
                        >
                          <option value={""}>{I18n.t('js.filters.defaultCardVersion')}</option>
                          {versions.map((version) => (
                            <option value={version} key={version}>
                              {titleize(version)}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.filters.sort.owner')}</p>
                        <select
                          className={`form-control ${filters.owner ? 'border-aiG-blue-imp' : ''} p-0`}
                          value={filters.owner ? filters.owner : ""}
                          name="owner_filter"
                          id="owner_filter"
                          onChange={(e) => getOffersByMatchingFilters('owner', e.target.value)}
                        >
                          <option value={""}>{I18n.t('js.filters.sort.owner')}</option>
                          {owners.map((owner) => (
                            <option value={owner[1]} key={owner[1]}>
                              {owner[0]}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.filters.sort.labelLanguage')}</p>
                        <select
                          className={`form-control ${filters.label_language ? 'border-aiG-blue-imp' : ''} p-0`}
                          value={filters.label_language ? filters.label_language : ""}
                          name="label_language_filter"
                          id="label_language_filter"
                          onChange={(e) => getOffersByMatchingFilters('label_language', e.target.value)}
                        >
                          <option value={""}>{I18n.t('js.filters.defaultLabelLanguage')}</option>
                          {label_languages.map((label_language) => (
                            <option value={label_language} key={label_language}>
                              {label_language.toUpperCase()}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.filters.sort.maxPrice')}</p>
                        <input
                          type="number"
                          min="0"
                          value={filters.max_price ? filters.max_price : ""}
                          className={`form-control ${filters.max_price ? 'border-aiG-blue-imp' : ''} p-1`}
                          placeholder={I18n.t('js.filters.defaultCardMinPrice')}
                          onChange={(e) => onChangeFilterPriceHandler(e.target.value)}
                          name="max_price_filter"
                          id="max_price_filter"
                        />
                      </div>

                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.filters.sort.minGrading')}</p>
                        <select
                          className={`form-control ${filters.grade_overall ? 'border-aiG-blue-imp' : ''} p-0`}
                          value={filters.grade_overall ? filters.grade_overall : ""}
                          name="grade_overall_filter"
                          id="grade_overall_filter"
                          onChange={(e) => getOffersByMatchingFilters('grade_overall', e.target.value)}
                        >
                          <option value={""}>{I18n.t('js.filters.defaultCardMinGrading')}</option>
                          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((grade_overall) => (
                            <option value={grade_overall} key={grade_overall}>
                              {grade_overall}
                            </option>
                          ))}
                        </select>
                      </div>

                      {
                        isBusinessAccount &&
                        <div className="col-lg-2 col-md-3 col-6 mb-2">
                          <p className="mb-0">{I18n.t('js.filters.sort.condition')}</p>
                          <select
                            className={`form-control ${filters.condition ? 'border-aiG-blue-imp' : ''} p-0`}
                            value={filters.condition ? filters.condition : ""}
                            name="condition_filter"
                            id="condition_filter"
                            onChange={(e) => getOffersByMatchingFilters('condition', e.target.value)}
                          >
                            <option value={""}>{I18n.t('js.filters.defaultCardCondition')}</option>
                            {[[I18n.t('js.myCollectionEditPage.condition.new'), 'new'],
                            [I18n.t('js.myCollectionEditPage.condition.used'), 'used']].map((condition) => (
                              <option value={condition[1]} key={condition[1]}>
                                {condition[0]}
                              </option>
                            ))}
                          </select>
                        </div>
                      }

                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.filters.sort.encasing')}</p>
                        <select
                          className={`form-control ${filters.encasing ? 'border-aiG-blue-imp' : ''} p-0`}
                          value={filters.encasing ? filters.encasing : ""}
                          name="encasing_filter"
                          id="encasing_filter"
                          onChange={(e) => getOffersByMatchingFilters('encasing', e.target.value)}
                        >
                          <option value={""}>{I18n.t('js.filters.defaultEncasing')}</option>
                          {[[I18n.t('js.common.submissionListType.sleeve') + ' / ' + I18n.t('js.common.submissionListType.sleeveExplanation'), 'sleeve'],
                          [I18n.t('js.common.submissionListType.case') + ' ' + I18n.t('js.common.submissionListType.caseExplanation'), 'case']].map((encasing) => (
                            <option value={encasing[1]} key={encasing[1]}>
                              {encasing[0]}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/*<div className="col-lg-2 col-md-3 col-6 mb-2">*/}
                      {/*  <p className="mb-0">{I18n.t('js.filters.sort.errors')}</p>*/}
                      {/*  <select*/}
                      {/*    className="form-control p-0"*/}
                      {/*    value={filters.has_errors ? filters.has_errors : ""}*/}
                      {/*    name="errors_filter"*/}
                      {/*    id="errors_filter"*/}
                      {/*    onChange={(e) => getOffersByMatchingFilters('has_errors', e.target.value)}*/}
                      {/*  >*/}
                      {/*    <option value={""}>{I18n.t('js.filters.sort.errors')}</option>*/}
                      {/*    {[['js.common.choice_yes', 'true'], ['js.common.choice_no', 'false']].map((has_errors) => (*/}
                      {/*      <option value={has_errors[1]} key={has_errors[1]}>*/}
                      {/*        {I18n.t(has_errors[0])}*/}
                      {/*      </option>*/}
                      {/*    ))}*/}
                      {/*  </select>*/}
                      {/*</div>*/}

                      <div className="col-lg-2 col-md-3 col-6 mb-2 mt-17px">
                        <button
                          className="btn-standard-outline br-20px mt-1 pt-1 pb-1 btn-standard-outline-resized w-100"
                          onClick={handleResetFilters}>
                          {I18n.t('js.filters.resetFilter')}
                        </button>
                      </div>

                      <div className="col-lg-2 col-md-3 col-6 mb-2 mt-17px show-on-mobile">
                        <button
                          className="btn-standard bg-aig-gradient text-light br-20px mt-1 pt-1 pb-1 pr-5 pl-5 btn-standard-outline-resized w-100"
                          onClick={(e) => setFilterPannelIsOpen(false)}>
                          {I18n.t('js.advancedSearch.filterComponent.search')}
                        </button>
                      </div>
                    </div>

                    <div className="row mb-2 mt-3">
                      <div className="col-12">
                        <h4 className="mt-0 mb-0">{I18n.t('js.indexOrdersPage.sortBy')}</h4>
                      </div>
                    </div>

                    <div className="row">
                      <div className=" col-xs-12 col-lg-4 d-flex justify-content-start align-items-center">
                        <select
                          className={`form-control ${filters.sort_by ? 'border-aiG-blue-imp' : ''} mr-1`}
                          name="sort_by" id="sort_by" value={filters.sort_by}
                          style={{ minWidth: "60%" }}
                          onChange={(e) => getOffersByMatchingFilters('sort_by', e.target.value)}>
                          {sorting_options.map(option => {
                            return <option value={option.value} key={option.value}>{I18n.t(option.locale)}</option>
                          })}
                        </select>
                        <span>
                          <b>:</b>
                        </span>
                        <select
                          className={`form-control ${filters.sorting_direction ? 'border-aiG-blue-imp' : ''} ml-1`}
                          name="sorting_direction" id="sorting_direction"
                          value={filters.sorting_direction}
                          onChange={(e) => getOffersByMatchingFilters('sorting_direction', e.target.value)}>
                          {sorting_directions.map(direction => {
                            return <option value={direction.value}
                              key={direction.value}>{I18n.t(direction.locale)}</option>
                          })}
                        </select>
                      </div>
                    </div>
                  </div>
                }
              </React.Fragment>
          }
        </div>

        <div className="w-90 m-auto">
          <div className="position-fixed w-100" style={{ background: 'white', top: '60px', zIndex: '100' }}>
            <div
              className={`${filterPannelIsOpen ? 'mt-my-collection-with-open-filter' : 'mt-5'}  title-core-pages row mb-3`}>
              <div className="col-12 col-lg-6 p-0">
                <h2 className="mt-0">{I18n.t('js.shopPage.title')}</h2>
              </div>

              <div className="col-6 d-none d-lg-block text-right" style={{ position: 'fixed', right: '0', zIndex: '10' }}>
                <SwitchDisplay switchTab={switchTab}
                  listTabColor={`${display == 'list' ? 'icon--color-active icon--bg-active' : 'icon--color-standard'}`}
                  blockTabColor={`${display != 'list' ? 'icon--color-active icon--bg-active' : 'icon--color-standard'}`} />
              </div>
            </div>

            {
              !loading && allProductsCount > 0 &&
              <div className="row mt-0">
                <div className="col-12 col-md-6">
                  <p>
                    {parseBigInteger(allProductsCount)}&nbsp;
                    {pluralize(allProductsCount, 'shopPage.availableProduct')}
                  </p>
                </div>

                <div className="col-12 col-md-6 text-right" style={{ position: `${window.innerWidth < IPAD_WIDTH ? 'inhert' : 'fixed'}`, right: `${window.innerWidth <= IPAD_WIDTH ? '20px' : '72px'}`, zIndex: '10' }}>
                  <button type="button"
                    id="add_all_to_cart"
                    className={`${window.innerWidth < IPAD_WIDTH && 'w-75 mr-5'} btn-standard bg-aig-gradient text-light br-20px shadow pr-4 pl-4 btn-standard-resized btn-buy-shop-index-fix`}
                    onClick={() => addCardToCartHandler(null)}>
                    {I18n.t('js.shopPage.addAllToCart')}
                  </button>
                </div>
              </div>
            }
          </div>

          {
            loading ?
              <div className={`${filterPannelIsOpen ? 'mt-505px-imp' : 'mt-190px-imp'} d-flex justify-content-center mt-5`}>
                <div className="d-flex align-items-center text-muted mt-5">
                  <div className="spinner-border" role="status" />
                  <b className="ml-2">{I18n.t('js.shopPage.loadingProducts')}</b>
                </div>
              </div>
              :
              offers.length > 0 ?
                <BottomScrollListener onBottom={getOffers}>
                  <div className={`${display === 'list' ? 'd-lg-block' : 'd-none'} show-on-desktop table-responsive`}>
                    <table id="cart-edit"
                      className={`table table-hover ${filterPannelIsOpen ? 'mt-505px-imp' : 'mt-190px-imp'} bg-white`}>
                      <thead className="thead-dark">
                        <tr>
                          <th scope="col" className="text-center">{I18n.t('js.filters.sort.cardPrice')}</th>
                          <th scope="col" className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderImage')}</th>
                          <th scope="col" className="text-center" />
                          <th scope="col" className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderName')}</th>
                          <th scope="col" className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderGame')}</th>
                          <th scope="col"
                            className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderCategory')}</th>
                          <th scope="col" className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderEra')}</th>
                          <th scope="col"
                            className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderExpansion')}</th>
                          <th scope="col" className="text-center">{I18n.t('js.filters.sort.owner')}</th>
                          <th scope="col" className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderLabel')}</th>
                          {
                            isBusinessAccount &&
                            <th scope="col"
                              className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderCondition')}</th>
                          }
                          <th scope="col"
                            className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderGrading')}</th>
                          {/*<th scope="col" className="text-center">{I18n.t('js.filters.sort.errors')}</th>*/}
                        </tr>
                      </thead>
                      <tbody>
                        {offers.map((offer, i) => {
                          return (<tr key={offer.id} id={offer.id}
                            className={offer.current_grading && offer.current_grading.is_valid && offer.current_grading.serial_number ? "cursor-pointer" : ""}
                            onClick={() => offer.current_grading && offer.current_grading.is_valid && offer.current_grading.serial_number ? window.location = `/grading_certificate/${offer.current_grading.serial_number}` : {}}>

                            <td className="text-center ml-td">
                              <p id={"price_" + offer.id}
                                className="text-weight-700">{parseAmount(offer.price) + CURRENCY_EURO}</p>

                              <React.Fragment>
                                {/*All'utente devo comunicare se un prodotto è ne suo carrello oppure no, ovvio solo nel caso in cui sia loggato.
                           Qui non inserisco il controllo sul login in quanto già offer.already_in_cart mi indica se l'utente è loggato o meno:
                          infatti se l'utente non è loggato non ho neppure il riferimento (id) al suo carrello, e la conseguenza di ciò è che offer.already_in_cart
                          abbia valore false.*/}
                                {!offer.already_in_cart ?
                                  (offer.enable_purchase &&
                                    <button type="button"
                                      className="btn-standard bg-aig-gradient text-light br-20px shadow btn-standard-resized text--size-09rem-imp text--white-space-no-wrap w-100 maxH-25px pt-3px-imp"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        addCardToCartHandler(offer.id);
                                      }}>
                                      <i className="fas fa-shopping-cart" /> &nbsp;
                                      {I18n.t("js.shopPage.addToCart")}
                                    </button>)
                                  :
                                  <p>
                                    {I18n.t("js.shopPage.thisProductIsIn")} <a
                                      href={`/carts/${offer.already_in_cart}/edit`}
                                      className="data-structure-link"
                                      style={{ color: "inherit", textDecoration: "underline" }}
                                      onClick={(e) => e.stopPropagation()}>
                                      {I18n.t("js.shopPage.yourCart")}
                                    </a>
                                  </p>
                                }
                                <button type="button"
                                  className="btn-standard bg-dark br-20px text-light pr-2 pl-2 btn-standard-resized h-auto btn-inside-table text--white-space-no-wrap mt-10px maxH-25px pt-2px-imp"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    window.location.href = `/products/${offer.blueprint_image.id}`;
                                  }}>
                                  {I18n.t("js.shopPage.compareOffers")}
                                </button>
                              </React.Fragment>
                            </td>

                            <BlueprintImageTableRaw
                              blueprintImage={offer.blueprint_image}
                              handleShowLargeImage={(e) => handleShowLargeImage(e, offer, offer.blueprint_image)}
                              id={offer.id}
                              displayEra={erasForFilter && erasForFilter.length > 0}
                            />

                            <td className="text-center ml-td">
                              <div className="d-block justify-content-center">
                                <p className="mb-2" id={"owner_" + offer.id}>{offer.user.username}</p>

                                {
                                  offer.enable_purchase &&
                                  <p>
                                    <small className="text-underline-imp text-aiBlue"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setSerialNumberToAskToSellerByEmail(offer.current_grading.serial_number);
                                      }}>
                                      {I18n.t("js.shopProductDetailModal.contactSeller")}
                                    </small>
                                  </p>
                                }
                              </div>
                            </td>
                            <td className="text-center ml-td">
                              <div className="d-block mb-0">
                                <LanguageFlag
                                  language={offer.current_grading.label_language}
                                  containerCssClassList={'d-flex justify-content-center'}
                                />

                                <EncasingParser
                                  encasing={offer.current_grading.encasing}
                                  categoryName={offer.blueprint_image.blueprint.category.name}
                                />
                              </div>
                            </td>
                            {
                              isBusinessAccount &&
                              <td className="text-center ml-td">
                                <p id={"condition_" + offer.id}
                                  className="mb-0">{parseItemCondition(offer.condition)}</p>
                              </td>
                            }
                            <td className="text-center ml-td">
                              <p id={"grade_overall_" + offer.id} className="text-weight-700 mt-0"
                                style={{ color: "green" }}>
                                {parseGradeOverall(offer.current_grading)}
                              </p>
                              <small>({offer.current_grading.serial_number})</small>

                              {
                                offer.current_grading.is_valid &&
                                <button type="button"
                                  id="aig-certificate"
                                  className="mt-10px btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized pt-4px-imp h-auto btn-inside-table text--white-space-no-wrap"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setBlueprintImage2ShowLargeImage(offer.blueprint_image);
                                    setProductToShowGradingCertificate(offer);
                                    setShowCertificate(true);
                                  }}
                                >
                                  {I18n.t("js.showCertificateModal.certificate")} &nbsp;
                                  <i className="fas fa-award" />
                                </button>
                              }
                            </td>

                          </tr>)
                        })}
                      </tbody>
                    </table>
                  </div>

                  <div className={`${display !== 'list' ? 'd-block' : 'd-none'} ${filterPannelIsOpen ? 'mt-505px-imp' : 'mt-190px-imp'}`}>
                    <div className={`${window.innerWidth < IPAD_WIDTH ? 'mt-200px-imp' : window.innerWidth < DESKTOP_WIDTH ? 'mt-150px-imp' : 'mt-10px-imp'} row d-flex m-auto`}>
                      {offers.map((offer, i) => {
                        const blueprintImageNames = displayTranslations(offer.blueprint_image.en_name, offer.blueprint_image.meta_name, offer.blueprint_image.language)

                        return (<div className="col-6 col-md-3 col-lg-2 transform-scale-09 p-0 text-lg-center" key={i}>
                          <div className="maxH-30px text-center position-relative">
                            <p className="text--truncate text-weight-700">
                              {blueprintImageNames[0]}
                            </p>
                          </div>

                          <ShowBlueprintImageFrontImage
                            size={"medium"}
                            product={offer}
                            blueprintImage={offer.blueprint_image}
                            handleShowLargeImage={handleShowLargeImage}
                            textOverlayPlaceholder={getArtwork(offer.blueprint_image)}
                          />

                          <div className="position-absolute shop-product-on-mobile shop-bottom-price">
                            <p className="text-weight-700 mb-0">{parseAmount(offer.price) + CURRENCY_EURO}</p>
                          </div>

                          <div className="row mt-10px">
                            <div className="col-12">

                              {/*All'utente devo comunicare se un prodotto è ne suo carrello oppure no, ovvio solo nel caso in cui sia loggato.
                           Qui non inserisco il controllo sul login in quanto già offer.already_in_cart mi indica se l'utente è loggato o meno:
                          infatti se l'utente non è loggato non ho neppure il riferimento (id) al suo carrello, e la conseguenza di ciò è che offer.already_in_cart
                          abbia valore false.*/}
                              {!offer.already_in_cart ?
                                (offer.enable_purchase &&
                                  <button type="button"
                                    id={`shop-add-to-cart-btn-${offer.blueprint_image.id}`}
                                    className="btn-standard bg-aig-gradient text-light br-20px shadow pr-1 pl-1 btn-standard-resized w-100 text--size-09rem w-on-lg-176px"
                                    onClick={() => addCardToCartHandler(offer.id)}
                                  >
                                    <i className="fas fa-shopping-cart icon-in-btn-size" />
                                    &nbsp;{I18n.t("js.shopPage.addToCart")}
                                  </button>)
                                :
                                <p className="text-center minH-40px-imp mb-0">
                                  <a
                                    id={`shop-link-to-cart-btn-${offer.blueprint_image.id}`}
                                    href={`/carts/${offer.already_in_cart}/edit`}
                                    className="data-structure-link"
                                    style={{ color: "inherit", textDecoration: "underline" }}>
                                    {I18n.t("js.shopPage.inYour")}
                                  </a>
                                </p>
                              }

                            </div>
                          </div>

                          <div className="row mt-10px">
                            <div className="col-12">
                              <button type="button"
                                id={`shop-info-btn-${offer.blueprint_image.id}`}
                                className="btn-standard bg-dark text-light btn-standard-resized p-2 w-100 text--size-09rem w-on-lg-176px"
                                onClick={() => showDetailOf(offer)}
                              >
                                <i className="fa fa-info-circle icon-in-btn-size" />&nbsp;
                                {I18n.t("js.shopPage.info")}
                              </button>
                            </div>
                          </div>

                        </div>)
                      })}
                    </div>
                  </div>
                  {
                    !hasLoadedAllOffers && offers.length > 0 &&
                    <div className="d-flex justify-content-center mt-5">
                      <div className="d-flex align-items-center text-muted">
                        <div className="spinner-border" role="status" />
                        <b className="ml-2">{I18n.t('js.common.loading')}</b>
                      </div>
                    </div>
                  }

                </BottomScrollListener>
                :
                <div className={`${filterPannelIsOpen ? 'mt-my-collection-with-open-filter' : 'mt-5'} d-flex justify-content-center pt-5`}>
                  <div className="d-flex align-items-center text-muted">
                    <b className="ml-2">{I18n.t('js.shopPage.noOffers')}</b>
                  </div>
                </div>
          }
        </div>
      </div>

      <SuccessModal
        showSuccessModal={showSuccessModal}
        setShowSuccessModal={setShowSuccessModal}
        successMessage={successMessage}
      />

      <ErrorModal
        showErrorModal={showErrorModal}
        setShowErrorModal={setShowErrorModal}
      />

      <SuccessFlashMessage
        showSuccessFlashMessage={showSuccessFlashMessage}
        setShowSuccessFlashMessage={setShowSuccessFlashMessage}
        successMessage={successFlashMessage}
      />

      <ShowLargeImageModal
        blueprintImage={blueprintImage2ShowLargeImage ? blueprintImage2ShowLargeImage : ''}
        showZoomImg={showZoomImg}
        setShowZoomImg={setShowZoomImg}
      />

      <GradingCertificate
        originalGradingCertificate={productToShowGradingCertificate ? productToShowGradingCertificate.current_grading : ''}
        originalBlueprintImage={blueprintImage2ShowLargeImage ? blueprintImage2ShowLargeImage : ''}
        showCertificate={showCertificate}
        setShowCertificate={setShowCertificate}
      />

      <RequiredLoginAlertPopup
        showRequiredLoginAlertPopup={showRequiredLoginModal}
        onClose={setShowRequiredLoginModal}
      />

      <SendEmailModal
        request={serialNumberToAskToSellerByEmail}
        setRequest={setSerialNumberToAskToSellerByEmail}
        emailFrom={emailFrom}
        setEmailFrom={setEmailFrom}
        handleSendEmail={handleSendEmailToSeller}
      />

      {
        offerToShow &&
        <ShopOffertDetailModal
          showShopProductDetailModal={showInfoOfferModal}
          onClose={setShowInfoOfferModal}
          offerToShow={offerToShow}
          handleBackNavigation={handleNavigation}
          isBusinessAccount={isBusinessAccount}
        />
      }
    </React.Fragment>
  )
};

export default OffersForMultipleBlueprintImages;
